// extracted by mini-css-extract-plugin
export var button = "dropdownMenu-module--button--eeb9b";
export var menuOpen = "dropdownMenu-module--menuOpen--f78c1";
export var open = "dropdownMenu-module--open--7b648";
export var panel = "dropdownMenu-module--panel--f671d";
export var wrapper = "dropdownMenu-module--wrapper--bc3d0";